<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    class="sidenav"
    fixedInViewport="true"
    #drawer
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a
        mat-list-item
        routerLink="/typography"
        >Typography</a
      >
      <a
        mat-list-item
        routerLink="/new-typography"
        >New Typography</a
      >
      <a
        mat-list-item
        routerLink="/colors"
        >Colors</a
      >
      <a
        mat-list-item
        routerLink="/new-colors"
        >New colors</a
      >
      <a
        mat-list-item
        routerLink="/form-controls"
        >Form Controls</a
      >
      <a
        mat-list-item
        routerLink="/layout"
        >Layout</a
      >
      <a
        mat-list-item
        routerLink="/buttons"
        >Buttons</a
      >
      <a
        mat-list-item
        routerLink="/navigation"
        >Navigation</a
      >
      <a
        mat-list-item
        routerLink="/dialog-modal"
        >Dialog / Modal</a
      >
      <a
        mat-list-item
        routerLink="/icons"
        >Icons</a
      >
      <a
        mat-list-item
        routerLink="/platform-button"
        >Platform / Button</a
      >
      <a
        mat-list-item
        routerLink="/platform-menu"
        >Platform / Menu</a
      >
      <a
        mat-list-item
        routerLink="/platform-input"
        >Platform / Input</a
      >
      <a
        mat-list-item
        routerLink="/platform-select"
        >Platform / Select</a
      >
      <a
        mat-list-item
        routerLink="/platform-switch"
        >Platform / Switch</a
      >
      <a
        mat-list-item
        routerLink="/platform-checkbox"
        >Platform / Checkbox</a
      >
      <a
        mat-list-item
        routerLink="/platform-drawer"
        >Platform / Drawer</a
      >
      <a
        mat-list-item
        routerLink="/platform-progress-indicator"
        >Platform / Progress indicator</a
      >
      <a
        mat-list-item
        routerLink="/platform-state-indicator"
        >Platform / State indicator</a
      >
      <a
        mat-list-item
        routerLink="/platform-status-marker"
        >Platform / Status marker</a
      >
      <a
        mat-list-item
        routerLink="/platform-action-ticker"
        >Platform / Action ticker</a
      >
      <a
        mat-list-item
        routerLink="/platform-datepicker"
        >Platform / Datepicker</a
      >
      <a
        mat-list-item
        routerLink="/platform-rangepicker"
        >Platform / Rangepicker</a
      >
      <a
        mat-list-item
        routerLink="/platform-message"
        >Platform / Message</a
      >
      <a
        mat-list-item
        routerLink="/platform-tabs"
        >Platform / Tabs</a
      >
      <a
        mat-list-item
        routerLink="/platform-radio"
        >Platform / Radio</a
      >
      <a
        mat-list-item
        routerLink="/platform-textarea"
        >Platform / Textarea</a
      >
      <a
        mat-list-item
        routerLink="/components"
        >Components</a
      >
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        *ngIf="isHandset$ | async"
        (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <div class="w-100 d-flex justify-content-between">
        <div>
          <span>Design Guideline</span>
        </div>
      </div>
    </mat-toolbar>

    <!-- Add Content Here -->
    <div class="container-fluid">
      <div class="mt-3 mx-3">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
